module.exports = __webpack_public_path__ + "img/creatives_for_climate.bd81ae1b.gif";